import React from 'react';
import { Bot, Save, Send } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';

const TelegramTab = ({ telegramSettings, onTelegramChange, onSave, saving, onTest, testingTelegram }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Bot className="h-5 w-5" /> Telegram Bot Notifications
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-6">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-sm text-blue-800">
        <p className="font-semibold mb-1">How to set up Telegram notifications:</p>
        <ol className="list-decimal list-inside space-y-1">
          <li>Create a bot via <a href="https://t.me/BotFather" target="_blank" rel="noopener noreferrer" className="underline font-medium">@BotFather</a> on Telegram</li>
          <li>Copy the Bot Token provided by BotFather</li>
          <li>Add the bot to your group/channel, or message it directly</li>
          <li>Get your Chat ID (use <a href="https://t.me/userinfobot" target="_blank" rel="noopener noreferrer" className="underline font-medium">@userinfobot</a> or check the bot API)</li>
        </ol>
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-xs text-amber-800">
        <p className="font-semibold">Security tip:</p>
        <p>For production, set <code className="bg-amber-100 px-1 rounded">TELEGRAM_BOT_TOKEN</code> and <code className="bg-amber-100 px-1 rounded">TELEGRAM_CHAT_ID</code> as deployment secrets instead of storing them here. Environment variables take priority over these settings.</p>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Bot Token</label>
          <Input name="bot_token" value={telegramSettings.bot_token} onChange={onTelegramChange} placeholder="123456789:ABCdefGHIjklMNOpqrsTUVwxyz" data-testid="telegram-bot-token" />
          <p className="text-xs text-gray-500 mt-1">The token provided by @BotFather</p>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Chat ID</label>
          <Input name="chat_id" value={telegramSettings.chat_id} onChange={onTelegramChange} placeholder="-1001234567890" data-testid="telegram-chat-id" />
          <p className="text-xs text-gray-500 mt-1">Your personal or group chat ID</p>
        </div>
        <label className="flex items-center gap-2">
          <input type="checkbox" name="enabled" checked={telegramSettings.enabled} onChange={onTelegramChange} className="rounded" />
          <span className="text-sm">Enable Telegram notifications</span>
        </label>
      </div>

      <div className="flex gap-2">
        <Button onClick={onSave} disabled={saving} data-testid="save-telegram-btn">
          <Save className="h-4 w-4 mr-2" /> {saving ? 'Saving...' : 'Save Telegram Settings'}
        </Button>
        <Button
          variant="outline"
          onClick={onTest}
          disabled={testingTelegram || !telegramSettings.bot_token || !telegramSettings.chat_id}
          data-testid="test-telegram-btn"
        >
          <Send className="h-4 w-4 mr-2" /> {testingTelegram ? 'Sending...' : 'Send Test'}
        </Button>
      </div>
    </CardContent>
  </Card>
);

export default TelegramTab;
